<template>
  <div v-if="resourceData != null" style="max-width: 1000px; margin: 0 auto;">
    <div class="columns is-centered">
      <div class="column fob-hide-in-print">
        <div class="level">
          <div class="level-left"></div>
          <!-- RESEARCH ACTIVITY | Actions like share and print -->
          <div class="level-right">
            <fob-public-list-quick-actions
              :qa-share="true"
              :qa-print="true"
            ></fob-public-list-quick-actions>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column">
        <fob-entity-header
          class="fob-entity-header"
          :type="resourceSchema.className"
          :title="resourceData._stringRep"
        ></fob-entity-header>
        <fob-entity-details
          class="fob-entity-details"
          :resourceData="resourceData"
          :resourceSchema="resourceSchema"
          :resourceId="resourceId"
          :linkProvider="linkProvider"
          :useCompactComponents="true"
          :isPublic="true"
        ></fob-entity-details>
        <div style="margin-top: 3rem" class="fob-hide-in-print">
          <router-link :to="currentPublicRoute()">
            <div class="button is-primary">
              <b-icon icon="arrow-left" size="is-small"></b-icon>
              <translate>Public.entity.backToList</translate>
            </div>
          </router-link>
          <a :href="portalEditLink" v-if="userCanEditByKostenstelle(resourceData)">
            <div class="button is-garnet">
              <b-icon icon="edit" size="is-small"></b-icon>
              <translate>component.entity.compact.edit</translate>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { graphql } from '@/axios'
import { detailsQuery } from '@/graphql'
import schema from '@/schema'
import EntityDetails from '@/components/EntityDetails'
import EntityHeader from '@/components/EntityHeader'
import PublicListQuickActions from '@/components/public/PublicListQuickActions'
import UserCanEditByKostenstelle from '@/components/mixins/UserCanEditByKostenstelle'
import ExternalLinkProvider from '@/components/mixins/ExternalLinkProvider'
import PublicRouteBuilder from '@/components/mixins/PublicRouteBuilder'

export default {
  mixins: [
    ExternalLinkProvider,
    PublicRouteBuilder,
    UserCanEditByKostenstelle,
  ],
  data () {
    return {
      resourceTypes: schema.baseTypes,
      resourceData: null,
      linkProvider: (data) => {
        if (data._entityName != null) {
          const type = data._entityName.split('.').splice(-1)[0].toLowerCase()
          if (type === 'organisationseinheit') {
            if (data._id !== '1' && data.hasOwnProperty('parentOrgaName') && data.parentOrgaName == null) {
              return null
            } else {
              return {
                name: 'public',
                params: {
                  type: 'ou',
                  id: data._id,
                  resourceType: 'forschungsprojekt'
                }
              }
            }
          } else if (type === 'person' && data.fisPersid != null) {
            return {
              name: 'public',
              params: {
                type: 'person',
                id: data.fisPersid,
                resourceType: 'forschungsprojekt'
              }
            }
          } else if (type === 'publikation' || type === 'forschungsprojekt') {
            return {
              name: 'public_details',
              params: {
                resourceType: type,
                resourceId: data._id
              }
            }
          }
        }
      }
    }
  },
  props: ['resourceType', 'resourceId'],
  components: {
    'fob-entity-details': EntityDetails,
    'fob-entity-header': EntityHeader,
    'fob-public-list-quick-actions': PublicListQuickActions
  },
  computed: {
    resourceSchema () {
      return this.resourceTypes.find(x => this.resourceType === x.schema.route).schema
    },
    internalId () {
      return this.resourceData._id
    }
  },
  beforeRouteUpdate (to, from, next) {
    const resourceId = Number(to.params.resourceId) || to.params.resourceId
    const query = detailsQuery[to.params.resourceType](resourceId)
    graphql(query)
    .then(response => {
      this.resourceData = response.data.data[to.params.resourceType]
      next()
    })
  },
  mounted () {
    const resourceId = Number(this.resourceId) || this.resourceId
    const query = detailsQuery[this.resourceType](resourceId)
    graphql(query)
    .then(response => {
      this.resourceData = response.data.data[this.resourceType]
      if (this.resourceData.primaryPublicIdent &&
          this.$route.params.resourceId !== this.resourceData.primaryPublicIdent) {
        let params = {
          ...this.$route.params,
          resourceId: this.resourceData.primaryPublicIdent
        }
        let newRoute = {
          name: this.$route.name,
          params
        }
        this.$router.replace(newRoute)
      }
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PublicEntity.vue